import React, { useState } from 'react';
import { Modal } from '../../elements/Modal';
import { Icon } from '../../elements/icon';
import Omega3EditorOption from './Omega3EditorOption';

const AddIngredientModal = ({ open, handleClose, allIngredients, data, removeIngredient, addIngredient, omega3Option }) => {
  return (
    <Modal
      open={open}
      handleClose={handleClose}
      className="t-w-full t-max-w-[90vw] sm:t-max-w-[500px] t-max-h-[80vh] !t-px-4 t-overflow-scroll hide-scrollbar"
      childrenClass=""
    >
      <div className="t-h-full t-w-full  t-flex t-flex-col t-items-center t-justify-center t-gap-4 t-py-4 t-overflow-scroll">
        {omega3Option && <Omega3EditorOption {...omega3Option} />}
        {/* SHI-583: ingredients switched off for D2C (d2c = 0, e.g. B2B-only ones) are not
            offered to customers. A missing flag counts as on. */}
        {allIngredients?.data?.filter((item) => Number(item?.d2c ?? 1) !== 0).map((item) => (
          <Row
            key={'item-row-' + item.id}
            data={data}
            removeIngredient={removeIngredient}
            addIngredient={addIngredient}
            item={item}
          />
        ))}
      </div>
    </Modal>
  );
};

const Row = ({ data, removeIngredient, addIngredient, item }) => {
  const [info, setInfo] = useState(false);
  const isSelected = data?.some(
    (ingredient) => Number(ingredient?.ingredient_id) === Number(item?.id),
  );

  return (
    <>
      <div className="t-w-full t-flex t-items-center t-justify-between t-gap-8">
        <div className="t-w-full t-flex t-items-center t-gap-2">
          {isSelected ? (
            <Icon name="checkCircle" size="18" color="#00A300" onClick={() => removeIngredient(item)} />
          ) : (
            <Icon name="plus" size="18" color="#003b4d" onClick={() => addIngredient(item)} />
          )}

          {/* The catalog is now fetched in the active language (SHI-554), so `ingredient`
              is already localised — including French, which the old `ingredient_de`
              ternary could not express and which fell through to English. */}
          <p className="t-m-0 t-text-base">{item?.ingredient}</p>
        </div>
        <Icon name="infoFilled" size="18" color="#003b4d" onClick={() => setInfo(!info)} />
      </div>
      {info && <p className="t-text-sm t-m-0">{item?.description}</p>}
    </>
  );
};

export default AddIngredientModal;
